import { useMutation, type MutationHookOptions } from "@apollo/client"
import tenantRestoreManyMutation from "@/v2-backoffice-client/tenant/restore/many/tenant.restore.many.mutation.gql"
import type {
  TenantRestoreManyMutation,
  TenantRestoreManyMutationVariables,
} from "@/v2-backoffice-client/tenant/restore/many/__types__/tenant.restore.many.mutation"

type RestoreOptions = MutationHookOptions<
  TenantRestoreManyMutation,
  TenantRestoreManyMutationVariables
>

export function useTenantRestoreManyMutation(options?: RestoreOptions) {
  return useMutation<
    TenantRestoreManyMutation,
    TenantRestoreManyMutationVariables
  >(tenantRestoreManyMutation, options)
}
